import { useMutation } from '@northladder/services';

import { COSMETIC_EVALUATION_API } from '../cosmeticEvaluationClient';

/**
 * This is to track the devices images list mutation.
 */
const DEVICE_IMAGES_LIST_MUT_KEY = 'devices-images-list-mut-key';

/**
 * This hook fetches a list of device dimensions details and tokens and urls to
 * which images would later be uploaded.
 * @deprecated - Remove this in favor of `useDeviceImagesListQuery` which is more
 *               flexible and allows for better control over the query.
 */
export const useDeviceImagesListMutation = () => {
  const { data, mutate, isPending, error } = useMutation({
    mutationKey: [DEVICE_IMAGES_LIST_MUT_KEY],
    networkMode: 'always',
    retry: false,
    mutationFn: COSMETIC_EVALUATION_API.fetchDeviceImageUploadsList,
  });

  return {
    data,
    error,
    isPending,
    fetchDevicesImagesList: mutate,
  };
};
